import { Center } from '@react-three/drei'
import { useRef } from 'react'
import { type Group } from 'three'

import { LocomotiveLights, LocomotiveModel, LocomotiveSmoke } from '@components/models'
import { useVehicleKinematics } from '@hooks'
import { RAIL_HEIGHT, useLocomotiveControls } from '@utils'

interface LocomotiveProps {
  id: string
}

export function Locomotive({ id }: LocomotiveProps) {
  const { smoke } = useLocomotiveControls()

  const ref = useRef<Group>(null)
  useVehicleKinematics(ref, id)

  return (
    <group ref={ref} name={id}>
      <Center position-y={RAIL_HEIGHT + 0.35}>
        <LocomotiveModel vehicleId={id} scale={[0.4, 0.4, 0.35]} />
      </Center>

      {smoke && <LocomotiveSmoke vehicleId={id} chimneyRef={ref} offset={[0, 0.65, 0.28]} />}
      <LocomotiveLights />
    </group>
  )
}
